import React from 'react';
import LazyLoadImageComponent from "common/components/LazyLoadImage";

function Exhibition(props) {

  const {
    title,
    cta,
    image,
    date,
  } = props;

  return (
    <div className='product-exhibition'>
      <picture>
        <source srcSet={image.image_desktop} media="(min-width: 1024px)" />
        <LazyLoadImageComponent
          src={image.uri}
          alt={image.alt}
        />
      </picture>
      <span className="product-exhibition__date">
          {date}
      </span>
      <h3 className='product-exhibition__title'>
        {title}
      </h3>
      {cta.label && (
        <a className='product-exhibition__button' href={cta.url}>{cta.label}</a>
      )}
    </div>
  );
}

export default  Exhibition;
